export default {
      id: "favorite-active-usage",
      viewBox: "0 0 17 25",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#favorite-active",
      toString: function () {
        return this.url;
      }
    }